export default __webpack_public_path__ + "images/question7_pic2.png";